import MapWoosmap from './MapWoosmap';

export default MapWoosmap;
